import { Modal } from "react-bootstrap"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"

import { saveProduct } from "../../../../models/products/products"
import ProductForm from "./ProductForm"


const CreateProductModal = ({ show, onHide }) => {
    const queryClient = useQueryClient()
    const { mutate, isLoading } = useMutation(product => saveProduct(product), {
        onSuccess: () => {
            toast.success('Success')
            queryClient.invalidateQueries([`products`])
            onHide()
        },
        onError: error => {
            toast.error(error.message)
        }
    })

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Create Product</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ProductForm onSubmit={data => mutate(data)} submitLoading={isLoading} />
            </Modal.Body>
        </Modal>
    )
}

export default CreateProductModal